// Нүүр — "Хийх зүйлс" (v0.1): хүүхдийн даалгавар (LMS даалгавар, хүүхэд бүрээр) | таны хийх зүйлс (эцэг эхийн todo) — 2 таб.
import React, { useState } from "react";
import { FiClock } from "react-icons/fi";
import { TodoCard } from "../Home/ParentDashboard";
import { md } from "./shared";

export default function ElemTodoCard({ overviews, todos }) {
  const kidTabs = overviews.map((o) => ({ key: `k${o.student.id}`, label: `${o.student.firstName}-ийн даалгавар`, tasks: o.tasks }));
  const tabs = [...kidTabs, { key: "me", label: "Таны хийх зүйлс" }];
  const [tab, setTab] = useState(kidTabs.find((t) => t.tasks.some((x) => !x.done))?.key || "me");
  const cur = tabs.find((t) => t.key === tab) || tabs[0];
  const count = (t) => (t.key === "me" ? todos.filter((x) => !x.done).length : t.tasks.filter((x) => !x.done).length);
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-1 p-1 rounded-xl bg-[#f3eeff] self-start" role="tablist">
        {tabs.map((t) => (
          <button key={t.key} type="button" role="tab" aria-selected={t.key === cur.key} onClick={() => setTab(t.key)}
            className={`h-9 px-3.5 rounded-[10px] text-sm font-semibold ${t.key === cur.key ? "bg-white text-primary shadow-sm" : "text-[#1c1c1c]"}`}>
            {t.label} · {count(t)}
          </button>
        ))}
      </div>
      {cur.key === "me" ? <TodoCard todos={todos} /> : (
        <section className="tj-card px-4 pt-[18px] pb-3 md:px-6 md:pt-6">
          <h2 className="m-0 text-xl md:text-[22px] font-bold">Хийх зүйлс</h2>
          <div className="text-sm text-[#6e5e8a] mb-1">Гэртээ хүүхэдтэйгээ хамт хийх даалгаврууд</div>
          {!cur.tasks.length ? <p className="m-0 py-3 text-sm text-[#6e5e8a]">Энэ 7 хоногт даалгавар алга.</p> : cur.tasks.map((t) => (
            <div key={t.id} className="flex items-start gap-3 py-3.5 border-t border-[#efedf4]">
              <span className={`mt-1 h-5 w-5 rounded-full border-2 shrink-0 ${t.done ? "bg-primary border-primary" : "border-primary"}`} />
              <span className="flex-1 min-w-0">
                <span className={`block text-[15px] md:text-base font-semibold ${t.done ? "line-through text-[#6e5e8a]" : ""}`}>{t.name}</span>
                {t.dueDate && <span className="inline-flex items-center gap-1 text-[13px] text-[#6e5e8a]"><FiClock size={13} />{md(t.dueDate)} хүртэл</span>}
              </span>
              {t.label && <span className="inline-flex items-center h-7 px-3 rounded-full bg-[#e0f7fa] text-[#0e7490] text-[13px] font-semibold whitespace-nowrap">{t.label}</span>}
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
